export const persianRed = "#3E7BF4"; //Azul de staffi
export const tuna = "#363740"; //Color de sidebar
export const white = "#ffffff";
export const doveGray = "#737373";
export const catskillWhite = "#E2E8F0"; // input disabled bg color
